import { observer } from "mobx-react-lite"
import "./about.css"
import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

const EventsCalendar = observer(() => {
    const { t } = useTranslation();
    
    return (
        <div>
            <h1> <span className="rubik">{t("EVENTS")}</span> <span className="blue-text">{t("CALENDAR")}</span></h1>
            <div className="row">
                <div className="features-description">{t("A calendar that understands your team, not just your deadlines.")}</div>
                <Flex justify="center">
                    <div className="list-features">
                        <div>{t("📅 All-in-one view")}</div>
                        <div>{t("🔍 Filter anything")}</div>
                        <div>{t("⚡ Create events in seconds")}</div>
                        <div>{t("⏱️ Time tracking built-in")}</div>
                        <div>{t("🔐 Access control")}</div>
                    </div>
                    <div className="features-image">
                        <img src={`/assets/about/tabs/${i18n.language}/event-calendar.svg`} alt="" />
                    </div>
                </Flex>
                <p className="features-description-center">{t("From birthdays to burnouts — stay one step ahead of the chaos.")}</p>
                <div className="blue-hr"></div>
            </div>
        </div>
    )
})
export default EventsCalendar;